<template>
  <div>
    <Header />
     <div class="mask2" v-if="loading">
      <div class="sub">
        <img src="@/assets/img/Spinner-1s-50px.svg" alt="">
      </div>
    </div>
    <div class="picture" v-html="content">
      <!-- <img src="../../../assets/images/child1.jpg" alt="">
      <img src="../../../assets/images/child2.jpg" alt=""> -->
    </div>
    <div class="code-bar">
    </div>
    <Concatc />
  </div>
</template>

<script>
import Header from '@/components/header/header';
import Concatc from '@/components/concatc/concatc';
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';
export default {
 components: {
    Header,
    Concatc
  },
  data(){
    return{
      id:'',
      content:'',
      loading:true,
    }
  },
  mounted(){
     this.id  = this.$router.currentRoute.query.id;
     this. getList();
  },
  methods:{
    // 获取信息
    getList(){
      let url = CONSTANT.PRODUCT.DETAIL+`?id=${this.id}`;
      common.postNoSess(url, null,null, res => {
        this.loading = false;
        console.log(res);
        this.content = res.data.bussData.content;
        // this.categoryList = data;
        // 获取顶部图片
      })
    },
  }
}
</script>

<style lang="less" scope>
  .picture{
    border-top: 1px solid #ccc;
    margin-bottom:100px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .mask2{
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height:100%;
    background: rgba(0,0,0,.5);
  .sub{
    img{
      width:80px;
      height: 80px;
    }
    margin-top:50%;
    text-align: center;
    p{
      font-size:26px;
      color: #fff;
    }
  }
}
  .code-bar{
    margin-left:50%;
    margin-bottom:80px;
    height:2px;
    background:rgba(89,87,87,1);
  }
</style>
